import { get, post } from './http';
import type { SessionUser } from './types';

export const authApi = {
  me: () => get<SessionUser>('/auth/me'),
  logout: () => post('/auth/logout'),
  wechatQrCode: () => get<{ qr_url: string; token: string }>('/auth/wechat/qr-code'),
  wechatOpenQrCode: () => get<{ token: string; appid: string; scope: string; redirect_uri: string; state: string }>('/auth/wechat/open-qr'),
  wechatQrStatus: (token: string) => get<Record<string, unknown>>(`/auth/wechat/qr-status?token=${token}`),
  wechatBind: (data: { key: string; name: string; phone: string }) => post<SessionUser>('/auth/wechat/bind', data),
  myOrgs: () => get<{ org_uuid: string; org_name: string }[]>('/auth/my-orgs'),
  switchOrg: (org_uuid: string) => post<SessionUser>('/auth/switch-org', { org_uuid }),
  switchToSuperAdmin: () => post<SessionUser>('/auth/switch-to-super-admin'),
  selectOrgInfo: (key: string) => get<{ orgs: { org_uuid: string; org_name: string }[] }>(`/auth/select-org-info?key=${key}`),
  selectOrg: (key: string, org_uuid: string) => post<SessionUser>('/auth/select-org', { key, org_uuid }),
  adminLoginScan: (token: string) => get<Record<string, unknown>>(`/auth/admin-login/scan/${token}`),
  adminLoginConfirm: (token: string, org_uuid?: string) => post(`/auth/admin-login/confirm/${token}`, { org_uuid }),
  adminLoginCancel: (token: string) => post(`/auth/admin-login/cancel/${token}`),
  createOrgInfo: (key: string) => get<{ valid: boolean }>(`/auth/create-org/info?key=${key}`),
  createOrgSubmit: (data: { key: string; name: string; contact?: string; phone?: string; address?: string }) => post<{ org_uuid: string; org_name: string }>('/auth/create-org/submit', data),
};

export const trialApi = {
  qrCode: () => post<{ id: number; token: string; appid: string; scope: string; redirect_uri: string; state: string; expire_at: string; qr_url: string }>('/trial/qr-code'),
  status: (token: string) => get<{ status: string; scenario?: string; org_name?: string; login_token?: string }>(`/trial/status?token=${token}`),
  login: (login_token: string) => post<{ message: string }>('/trial/login', { login_token }),
};
